import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../../../redux/store';
import { MainOrSidePotContainer } from './mainOrSidePotContainer';
const POT_SPACING_PX = 22;
export const AllPotsContainer = () => {
    const mainPotX = useAppSelector((state) => state.gameDimensions.mainPotCoords?.x);
    const mainPotY = useAppSelector((state) => state.gameDimensions.mainPotCoords?.y);
    const amounts = useAppSelector((state) => state.poker.potAmounts, shallowEqual);
    if (mainPotX === undefined || mainPotY === undefined || !amounts.length || amounts[0] === 0) {
        return null;
    }
    return (_jsx(Container, { x: mainPotX, y: mainPotY, interactiveChildren: false, children: amounts.map((amount, i) => {
            const y = i * POT_SPACING_PX;
            return _jsx(MainOrSidePotContainer, { x: 0, y: y, potIndex: i, amount: amount, numPots: amounts.length }, i);
        }) }));
};
